import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { PrivateTeamTypeModel } from 'src/models';

const privateTeamTypeAdapter: AdapterFunc<GQL.PrivateTeamTypeModel, PrivateTeamTypeModel> = (
  input,
) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default privateTeamTypeAdapter;
